import { computed } from 'vue'
import { useQuery, useMutation } from '/@/core/graphql'
import { gql } from '@apollo/client/core'
import {
  type ImagesInput,
  type ImageUpdateNameInput,
  type Image,
} from './types'
import { type Image as ThingImage } from '/@/common/things/types'
import { myKudosFragment } from '/@/common/kudos/fragments'

export function useImageDetailsData(imageId: string) {
  const { result, loading, error } = useQuery<{ image: ThingImage }>(
    gql`
      ${myKudosFragment}
      query getImageDetail($id: String!) {
        image(id: $id) {
          id
          thingType
          name
          bookmarkInfo {
            id
          }
          url
          addedByDesignerId
          addedBy {
            id
            firstName
            lastName
            imageUrl
            nickname
          }
          allKudos {
            count
          }
          myKudos {
            ...MyKudosProps
          }
        }
      }
    `,
    {
      id: computed(() => imageId),
    },
  )

  const image = computed(() => result.value?.image)

  return { image, loading, error }
}

export function useImages() {
  const { mutate: add } = useMutation(gql`
    mutation commonAddImage($input: ImagesInput!) {
      image {
        add(input: $input) {
          records {
            id
            name
            url
            paletteApiUrl
          }
        }
      }
    }
  `)

  const { mutate: updateName } = useMutation(gql`
    mutation updateImageName($input: NameInput!) {
      image {
        updateName(input: $input) {
          recordId
          status
          record {
            id
            name
          }
        }
      }
    }
  `)

  return {
    async add(input: ImagesInput): Promise<Image[] | undefined> {
      const response = await add({ input })
      return response?.data?.image?.add?.records
    },
    async updateName(input: ImageUpdateNameInput): Promise<Image | undefined> {
      const response = await updateName({ input })
      return response?.data?.image?.updateName?.record
    },
  }
}
